export enum CategoriesActionTypes {
  GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST',
  GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS',
  GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE',

  GET_CATEGORY_DETAILS_REQUEST = 'GET_CATEGORY_DETAILS_REQUEST',
  GET_CATEGORY_DETAILS_SUCCESS = 'GET_CATEGORY_DETAILS_SUCCESS',
  GET_CATEGORY_DETAILS_FAILURE = 'GET_CATEGORY_DETAILS_FAILURE',
}
